import { transform } from 'lodash';
import moment from 'moment-timezone';
import React, { Component } from 'react';
import { EntityCrud } from '../../../components/EntityCRUD';
import { SubscriptionService } from '../services/SubscriptionService';

class SubscriptionCRUD extends Component {

    constructor() {
        super();

        this.state = {
            processing: false
        }
    }

    statusParse(status) {
        const statuses = {
            "ACTIVE": "Ativa",
            "WAITING_PAYMENT": "Aguardando Pagamento",
            "EXPIRED": "Expirada",
            "CANCELLED": "Cancelada"
        }

        return statuses[status] || status;
    }

    formatPrice(price) {
        return parseFloat("" + price).toLocaleString('pt-BR',{minimumFractionDigits: 2, style: 'currency', currency: 'BRL'})
    }

    render() {        
        return <EntityCrud
            module="subscriptions"
            entity="subscriptions"
            permission="MANAGE_SUBSCRIPTIONS"
            config={{
                title: "Manage_Subscriptions",
                allowedOperations: ["VIEW"],
                listAttributes: [
                    { label: "Customer", value: "customer.name" },
                    { label: "SubscriptionPlan", value: "config.plan.name" },
                    { label: "Status", value: "config.status", transform: this.statusParse },
                    { label: "Start", value: "config.starts_on" },
                    { label: "End", value: "config.ends_on" }
                ],
                globalOperations: [
                    { 
                        label: "Sincroniza com Conta Azul", 
                        icon: "pi-refresh", 
                        successMessage: "Sincronizacao realizada com sucesso",
                        condition: () => true, 
                        operation: async () => { 
                            this.setState({ processing: true });
                            const subscriptionService = new SubscriptionService();
                            await subscriptionService.syncContaAzul();
                            this.setState({ processing: false });
                        } 
                    }
                ],
                view: {
                    title: "Assinatura",
                    attributes: [
                        { label: "Name", value: "customer.name", group: 'customer', columns: 4 },
                        { label: "Type", value: "customer.type", group: 'customer', columns: 4  },
                        { label: "RegistrationNumber", value: "customer.registration_number", group: 'customer', columns: 4  },
                        { label: "Name", value: "config.plan.name", group: 'plan', columns: 4  },
                        { label: "Expiration", value: "config.plan.config.expiration_in_months", group: 'plan', columns: 4  },
                        { label: "Price", value: "config.plan.config.price", group: 'plan', columns: 4, transform: this.formatPrice },
                        { label: "Status", value: "config.status", transform: this.statusParse, group: 'subscription', columns: 4  },
                        { label: "Start", value: "config.starts_on", group: 'subscription', columns: 4  },
                        { label: "End", value: "config.ends_on", group: 'subscription', columns: 4  },
                        { label: "Parcelas", value: "config.contaAzulSales", 
                            listColumns: [
                                { id: "number", label: "Número" },
                                { id: "emission", label: "Emissão", transform: (data) => data ? moment(data).format("YYYY-MM-DD") : "-" },
                                { id: "total", label: "Valor", transform: this.formatPrice },
                                { id: "payment.installments[0].due_date", label: "Vencimento", transform: (data) => data ? moment(data).format("YYYY-MM-DD") : "-" },
                                { id: "payment.installments[0].status", label: "Status", transform: (status) => {
                                    if((status || "") === "ACQUITTED") return "Pago";
                                    else if((status || "") === "PENDING") return "Em Aberto";
                                    else if((status || "") === "") return "Em Aberto";
                                    else return status;
                                } },
                                { id: "notes", label: "Notas" }
                            ], group: 'installments', columns: 12  },
                        { label: "ID", value: "config.mercadoPagoId", group: 'mp', columns: 12  },
                        
                    ],
                    groups: [
                        { key: 'customer', label: 'Customer' },
                        { key: 'plan', label: 'SubscriptionPlan' },
                        { key: 'subscription', label: 'Subscription' },
                        { key: 'mp', label: 'Mercado Pago' },
                        { key: 'installments', label: 'Conta Azul' }
                    ],
                    operations: [
                        // { 
                        //     label: "Confirmar Pagamento", 
                        //     icon: "pi-check", 
                        //     condition: (item) => ["WAITING_PAYMENT"].indexOf((item.config || {}).status || "") >= 0, 
                        //     operation: async (item) => { 
                        //         this.setState({ processing: true });
                        //         const subscriptionService = new SubscriptionService();
                        //         await subscriptionService.confirmSubscription(item.id)
                        //         this.setState({ processing: false });
                        //     } 
                        // },
                        // { 
                        //     label: "Cancelar", 
                        //     icon: "pi-times", 
                        //     condition: (item) => ["WAITING_PAYMENT","ACTIVE"].indexOf((item.config || {}).status || "") >= 0, 
                        //     operation: async (item) => { 
                        //         this.setState({ processing: true });
                        //         const subscriptionService = new SubscriptionService();
                        //         await subscriptionService.cancelSubscription(item.id);
                        //         this.setState({ processing: false });
                        //     } 
                        // }
                    ]
                }
            }}
            processing={this.state.processing}
        />
    }
}

export default SubscriptionCRUD;